document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("searchInput");
  const suggestionsList = document.getElementById("suggestionsList");
  const genderInput = document.getElementById("genderFilter");
  const searchSubmit = document.getElementById("searchSubmit");
  const searchDrawer = document.getElementById("searchDrawer");
  const searchButton = document.querySelectorAll("[data-search-open]");
  const closeButton = document.getElementById("closeDrawer");
  const tabs = document.querySelectorAll(".tab");

  // Cache for designers with their links
  let menDesigners = [];
  let womenDesigners = [];
  let designersLoaded = false;

  // Gender-specific categories configuration
  const genderCategories = {
    men: {
      clothing: [
        "Outerwear",
        "Coats",
        "Bomber Jackets",
        "Denim Jackets",
        "Leather Jackets",
        "Jackets",
        "Puffers",
        "Blazers",
        "Vests",
        "Fur & Shearling",
        "Ponchos",
        "Kimonos",
        "Tops",
        "Shirting",
        "T-Shirts",
        "Henleys",
        "Tanks",
        "Sweaters",
        "Crewnecks",
        "Hoodies",
        "Cardigans",
        "Turtlenecks",
        "Pants",
        "Trousers",
        "Jeans",
        "Joggers",
        "Cropped",
        "Leather",
        "Suits",
        "Suiting",
        "Waistcoats",
        "Shorts",
        "Swimwear",
        "Jumpsuits",
      ],
      accessories: [
        "Jewelry",
        "Rings",
        "Bracelets",
        "Necklaces",
        "Watches",
        "Bags",
        "Backpacks",
        "Hand & Shoulder Bags",
        "Eyewear",
        "Sunglasses",
        "Glasses",
        "Hats",
        "Caps",
        "Beanies",
        "Brimmed Hats",
        "Gloves",
        "Scarves",
        "Wallets",
        "Belts",
        "Socks",
        "Scents",
        "Home",
      ],
      footwear: [
        "Shoes",
        "Boots",
        "Sneakers",
        "Sneakers High-Top",
        "Sneakers Low-Top",
        "Sandals",
        "Loafers",
      ],
      sale: [
        "Sale Outerwear",
        "Sale Tops",
        "Sale Bottoms",
        "Sale Footwear",
        "Sale Accessories",
      ],
    },
    women: {
      clothing: [
        "Outerwear",
        "Coats",
        "Bomber Jackets",
        "Denim Jackets",
        "Leather Jackets",
        "Jackets",
        "Blazers",
        "Vests",
        "Fur & Shearling",
        "Kimonos",
        "Ponchos",
        "Tops",
        "Shirting",
        "Blouses",
        "T-Shirts",
        "Tanks",
        "Bodysuits",
        "Tops Cropped",
        "Bras",
        "Corsets",
        "Sweaters",
        "Crewnecks",
        "Hoodies",
        "Cardigans",
        "Turtlenecks",
        "Pants",
        "Trousers",
        "Jeans",
        "Leggings",
        "Joggers",
        "Pants Cropped",
        "Leather",
        "Shorts",
        "Skirts",
        "Dresses",
        "Short",
        "Mid Length",
        "Long",
        "Jumpsuits",
        "Swimwear",
      ],
      accessories: [
        "Jewelry",
        "Rings",
        "Bracelets",
        "Necklaces",
        "Chokers",
        "Earrings",
        "Bags",
        "Purses",
        "Clutches",
        "Backpacks",
        "Shoulder Bags",
        "Eyewear",
        "Sunglasses",
        "Glasses",
        "Hats",
        "Caps",
        "Beanies",
        "Brimmed Hats",
        "Headwear",
        "Gloves",
        "Scarves",
        "Wallets",
        "Belts",
        "Socks",
        "Scents",
        "Home",
      ],
      footwear: ["Shoes", "Boots", "Heels", "Flats", "Sandals", "Sneakers"],
      sale: [
        "Sale Outerwear",
        "Sale Tops",
        "Sale Bottoms",
        "Sale Dresses",
        "Sale Footwear",
        "Sale Accessories",
      ],
    },
  };

  // Get categories based on gender
  function getCategoriesForGender(gender) {
    if (gender === "men") {
      return {
        main: ["Clothing", "Accessories", "Footwear", "Sale"],
        all: [
          ...genderCategories.men.clothing,
          ...genderCategories.men.accessories,
          ...genderCategories.men.footwear,
          ...genderCategories.men.sale,
        ],
      };
    } else if (gender === "women") {
      return {
        main: ["Clothing", "Accessories", "Footwear", "Sale"],
        all: [
          ...genderCategories.women.clothing,
          ...genderCategories.women.accessories,
          ...genderCategories.women.footwear,
          ...genderCategories.women.sale,
        ],
      };
    }
  }

  // Filter collections based on gender-specific categories
  function filterCollectionsByGender(collections, gender, searchTerm) {
    const categories = getCategoriesForGender(gender);

    return collections.filter((collection) => {
      const title = collection.title.toLowerCase();
      const term = searchTerm.toLowerCase();

      // Check if collection title matches search term
      const matchesSearch = title.includes(term);

      // Check if collection belongs to gender-specific categories
      const matchesCategory = categories.all.some(
        (cat) =>
          title.includes(cat.toLowerCase()) || cat.toLowerCase().includes(title)
      );

      // For gender-specific searches, also check if it contains gender keyword
      let matchesGender = true;
      if (gender === "men" || gender === "women") {
        matchesGender =
          title.includes(gender) ||
          collection.handle?.includes(gender) ||
          !title.includes(gender === "men" ? "women" : "men");
      }

      return matchesSearch && (matchesCategory || matchesGender);
    });
  }

  // Generate category suggestions based on search term and gender
  function generateCategorySuggestions(searchTerm, gender) {
    const categories = getCategoriesForGender(gender);
    const term = searchTerm.toLowerCase();

    return categories.all
      .filter(
        (category) =>
          category.toLowerCase().includes(term) ||
          term.includes(category.toLowerCase())
      )
      .slice(0, 5);
  }

  // Method 1: Fetch from Liquid-rendered data (Best approach)
  function loadDesignersFromWindow() {
    if (window.shopifyDesigners) {
      menDesigners = window.shopifyDesigners.men || [];
      womenDesigners = window.shopifyDesigners.women || [];
      designersLoaded = true;
      return true;
    }
    return false;
  }

  // Method 2: Parse from existing DOM elements
  function loadDesignersFromDOM() {
    try {
      // Men designers from navigation menu
      const menMenuItems = document.querySelectorAll(
        '#menu-designers-men a, [data-menu="designers-men"] a'
      );
      menDesigners = Array.from(menMenuItems)
        .map((link) => ({
          name: link.textContent.trim(),
          url: link.href,
        }))
        .filter((item) => item.name);

      // Women designers from navigation menu
      const womenMenuItems = document.querySelectorAll(
        '#menu-designers-women a, [data-menu="designers-women"] a'
      );
      womenDesigners = Array.from(womenMenuItems)
        .map((link) => ({
          name: link.textContent.trim(),
          url: link.href,
        }))
        .filter((item) => item.name);

      designersLoaded = menDesigners.length > 0 || womenDesigners.length > 0;
      return designersLoaded;
    } catch (error) {
      console.warn("Could not load designers from DOM:", error);
      return false;
    }
  }

  // Method 3: Fetch using Search API with specific collections
  async function loadDesignersFromSearch() {
    try {
      const [menResponse, womenResponse] = await Promise.all([
        fetch(
          `/search/suggest.json?q=&resources[type]=collection&resources[options][fields]=handle,title&resources[limit]=50`
        ).then((res) => res.json()),
        fetch(
          `/search/suggest.json?q=&resources[type]=product&resources[options][fields]=vendor&resources[limit]=100`
        ).then((res) => res.json()),
      ]);

      // Get collections with "men" or "women" in handle
      const collections = menResponse.resources?.results?.collections || [];
      const products = womenResponse.resources?.results?.products || [];

      // Filter designers from collections
      const menCollections = collections.filter(
        (c) => c.handle?.includes("men") || c.handle?.includes("designer")
      );
      const womenCollections = collections.filter(
        (c) => c.handle?.includes("women") || c.handle?.includes("designer")
      );

      // Get unique vendors as designers with search links
      const allVendors = [
        ...new Set(products.map((p) => p.vendor).filter(Boolean)),
      ];

      // For now, split vendors between men/women (you can customize this logic)
      menDesigners = allVendors
        .slice(0, Math.ceil(allVendors.length / 2))
        .map((vendor) => ({
          name: vendor,
          url: `/search?q=${encodeURIComponent(vendor)}`,
        }));
      womenDesigners = allVendors
        .slice(Math.ceil(allVendors.length / 2))
        .map((vendor) => ({
          name: vendor,
          url: `/search?q=${encodeURIComponent(vendor)}`,
        }));

      designersLoaded = true;
      return true;
    } catch (error) {
      console.warn("Could not load designers from search API:", error);
      return false;
    }
  }

  // Method 4: Direct collection fetch (if collections exist)
  async function loadDesignersFromCollections() {
    try {
      const responses = await Promise.all([
        fetch("/collections/designers-men?view=ajax")
          .then((res) => res.text())
          .catch(() => ""),
        fetch("/collections/designers-women?view=ajax")
          .then((res) => res.text())
          .catch(() => ""),
      ]);

      // Parse HTML to extract designer names with links
      const parser = new DOMParser();

      responses.forEach((html, index) => {
        if (html) {
          const doc = parser.parseFromString(html, "text/html");
          const designerElements = doc.querySelectorAll(
            "a[data-vendor], a .vendor, a .designer-name"
          );
          const designers = Array.from(designerElements)
            .map((el) => {
              const link = el.tagName === "A" ? el : el.closest("a");
              return {
                name: el.textContent.trim(),
                url: link
                  ? link.href
                  : `/search?q=${encodeURIComponent(el.textContent.trim())}`,
              };
            })
            .filter((item) => item.name);

          if (index === 0) menDesigners = designers;
          else womenDesigners = designers;
        }
      });

      designersLoaded = menDesigners.length > 0 || womenDesigners.length > 0;
      return designersLoaded;
    } catch (error) {
      console.warn("Could not load designers from collections:", error);
      return false;
    }
  }

  // Initialize designers using multiple methods
  async function initializeDesigners() {
    if (designersLoaded) return;

    // Try methods in order of reliability
    const methods = [
      loadDesignersFromWindow,
      loadDesignersFromDOM,
      loadDesignersFromCollections,
      loadDesignersFromSearch,
    ];

    for (const method of methods) {
      try {
        const success = await method();
        if (success) {
          console.log("Designers loaded successfully");
          break;
        }
      } catch (error) {
        console.warn("Method failed:", error);
      }
    }

    // Fallback: hardcode some popular designers if nothing works
    if (!designersLoaded) {
      console.warn("No designers loaded from any source.");
    }
  }

  // Get designers based on gender
  function getDesignersForGender(gender) {
    switch (gender) {
      case "men":
        return menDesigners;
      case "women":
        return womenDesigners;
      default:
        return [];
    }
  }

  // Clean suggestion text (remove backend terms like "(women)", "(men)")
  function cleanSuggestionText(text) {
    return text
      .replace(/\s*\([^)]*\)\s*/g, "") // Remove text in parentheses
      .replace(/\s*\[[^\]]*\]\s*/g, "") // Remove text in brackets
      .trim();
  }

  // Generate search URL based on gender filter
  // function getSearchUrl(term, gender) {
  //   if (gender === 'men') {
  //     // For Men tab, include gender=1 in the search URL
  //     return `/search?q=${encodeURIComponent(term)}&gender=1`;
  //   } else if (gender === 'women') {
  //     // For Women tab, include gender=0 in the search URL
  //     return `/search?q=${encodeURIComponent(term)}&gender=0`;
  //   } else {
  //     // Default behavior: Return just the search term
  //     return `/search?q=${encodeURIComponent(term)}`;
  //   }
  // }
  function getSearchUrl(term, gender) {
    const normalized = term.trim().toLowerCase();
    const cats = genderCategories[gender]?.clothing
      .concat(
        genderCategories[gender].accessories || [],
        genderCategories[gender].footwear || []
      )
      .concat(genderCategories[gender].sale || []);

    // If we match a category exactly
    const matched = cats.find((cat) => cat.toLowerCase() === normalized);
    if (matched) {
      const handle = matched.toLowerCase().replace(/\s+/g, "-");
      return `/collections/${gender}s-new-arrivals/${handle}`;
    }

    const encodedTerm = encodeURIComponent(term).replace(/%20/g, "+");

    // Fallback to original logic
    if (gender === "men") {
      return `/search?q=${encodedTerm}&gender=1`;
    } else if (gender === "women") {
      return `/search?q=${encodedTerm}&gender=0`;
    } else {
      return `/search?q=${encodedTerm}`;
    }
  }

  // Open drawer
  if (searchButton) {
    searchButton.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (searchDrawer) {
          searchDrawer.classList.remove("hidden");
          initializeDesigners(); // Load designers when opening
        }
      });
    });
  }

  // Close drawer
  if (closeButton) {
    closeButton.addEventListener("click", () => {
      searchDrawer.classList.add("hidden");
    });
  }

  // Tab switching
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      input.value = "";
      suggestionsList.classList.add("hidden");
      suggestionsList.innerHTML = "";

      const filter = tab.dataset.filter;
      const gender = tab.dataset.gender;
      input.placeholder = `Search ${
        filter.charAt(0).toUpperCase() + filter.slice(1)
      }`;
      genderInput.value = gender;
    });
  });

  // Enhanced input typing for suggestions
  let debounceTimeout;
  let latestInputValue = "";

  input.addEventListener("input", () => {
    const value = input.value.trim();
    const gender = genderInput.value;

    clearTimeout(debounceTimeout);

    if (value.length <= 1) {
      suggestionsList.classList.add("hidden");
      suggestionsList.innerHTML = "";
      return;
    }

    // Set this value to avoid race conditions
    latestInputValue = value;

    debounceTimeout = setTimeout(async () => {
      await initializeDesigners();

      const query = `${value} ${gender}`;
      const suggestionsResponse = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          query
        )}&resources[type]=product,collection,query`
      )
        .then((res) => res.json())
        .catch(() => ({ resources: { results: {} } }));

      // Ensure input has not changed since debounce started
      if (input.value.trim() === latestInputValue) {
        renderSuggestions(
          suggestionsResponse.resources.results,
          latestInputValue,
          gender
        );
      }
    }, 200); // Adjust debounce delay as needed
  });

  // Fetch tags for a vendor (designer)
  async function fetchTagsForVendor(vendorName) {
    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(
          vendorName
        )}&resources[type]=product&resources[options][fields]=vendor&resources[limit]=20`
      );
      const json = await response.json();
      const products = json.resources?.results?.products || [];

      const tagCount = {};
      products.forEach((product) => {
        (product.tags || []).forEach((tag) => {
          const tagLower = tag.toLowerCase();
          console.log("tagLower===", tagLower);
          tagCount[tagLower] = (tagCount[tagLower] || 0) + 1;
        });
      });

      console.log("tagCount===", tagCount);

      return Object.entries(tagCount)
        .sort((a, b) => b[1] - a[1])
        .map(([tag]) => tag);
    } catch (error) {
      console.warn("Error fetching tags for vendor:", vendorName, error);
      return [];
    }
  }

  // Renders suggestions in dropdown with proper section management
  async function renderSuggestions(results, term, gender) {
    try {
      const { products = [], collections = [], queries = [] } = results;

      function flattenDesigners(designers) {
        const flat = [];
        function recurse(items) {
          items.forEach((item) => {
            if (item.name && item.url)
              flat.push({ name: item.name, url: item.url });
            if (item.children && Array.isArray(item.children))
              recurse(item.children);
          });
        }
        recurse(designers);
        return flat;
      }

      const rawDesigners = getDesignersForGender(gender);
      const designers = flattenDesigners(rawDesigners);
      const filteredDesigners = designers
        .filter((d) => d.name.toLowerCase().includes(term.toLowerCase()))
        .slice(0, 5);

      // Helper function to update section content
      function updateSectionContent(
        sectionSelector,
        labelText,
        items,
        isSearchLink = false
      ) {
        let section = suggestionsList.querySelector(sectionSelector);

        if (items.length === 0 && !isSearchLink) {
          if (section) section.style.display = "none";
          return;
        }

        if (!section) {
          section = document.createElement("div");
          section.className = sectionSelector.replace(".", "");
          suggestionsList.appendChild(section);
        }

        section.style.display = "block";
        section.innerHTML = "";

        if (!isSearchLink && labelText) {
          const label = document.createElement("li");
          label.className = "group-label";
          label.textContent = labelText;
          section.appendChild(label);
        }

        items.forEach((item) => {
          const li = document.createElement("li");

          if (isSearchLink) {
            li.className = "search-link";
            li.innerHTML = item.html;
          } else {
            li.className = "suggestion";
            li.textContent = item.label;
            li.addEventListener("click", () => {
              input.value = item.label;
              suggestionsList.classList.add("hidden");
              window.location.href = item.url;
            });
          }

          section.appendChild(li);
        });
      }

      // === DESIGNERS SECTION ===
      const designersData = filteredDesigners.map((designer) => ({
        label: designer.name,
        url: designer.url,
      }));

      // === TAG-BASED CATEGORY SUGGESTIONS ONLY (MAX 4) ===
      const combinedSuggestions = [];
      const bannedTags = [
        "women",
        "men",
        "clothing",
        "accessories",
        "footwear",
        "sale",
        "apparel",
        "fashion",
        "style",
        "new",
        "latest",
      ];
      // all tag show logic
      // for (const designer of filteredDesigners) {
      //   const tags = await fetchTagsForVendor(designer.name);
  

      //   for (const tag of tags) {
      //     const tagLower = tag.toLowerCase();
      //       if (combinedSuggestions.length >= 4 || bannedTags.includes(tagLower)) continue;
            
      //       const vendorUrlParts = designer.url.split("/").filter(Boolean);
      //       const vendorHandle =
      //         vendorUrlParts[vendorUrlParts.length - 1] ||
      //         designer.name.toLowerCase().replace(/\s+/g, "-");
      //       const tagHandle = tagLower.replace(/[\/\s]+/g, "-");
            
      //       // Remove "men", "women", "woemn" from display only
      //       const cleanedTag = tagLower
      //         .replace(/^(men|women|woemn)[-_]*/i, "")
      //         .replace(/-/g, " ") 
      //         .trim();
            
      //       combinedSuggestions.push({
      //         label: `${designer.name} ${cleanedTag}`,
      //         url: `/collections/${vendorHandle}/${tagHandle}`, // URL stays unchanged
      //       });


      //   }

      //   if (combinedSuggestions.length >= 4) break;
      // }

      // highpriority tag show first
      const priorityTags = ["tops", "dress", "dresses","shorts","pants","blazers","sneakers","sneakers"]; 
let tempSuggestions = [];

for (const designer of filteredDesigners) {
  const tags = await fetchTagsForVendor(designer.name);

  for (const tag of tags) {
    const tagLower = tag.toLowerCase();
    if (bannedTags.includes(tagLower)) continue;

    const vendorUrlParts = designer.url.split("/").filter(Boolean);
    const vendorHandle =
      vendorUrlParts[vendorUrlParts.length - 1] ||
      designer.name.toLowerCase().replace(/\s+/g, "-");
    const tagHandle = tagLower.replace(/[\/\s]+/g, "-");

    const cleanedTag = tagLower
      .replace(/^(men|women|woemn)[-_]*/i, "")
      .replace(/-/g, " ")
      .trim();

    tempSuggestions.push({
      label: `${designer.name} ${cleanedTag}`,
      url: `/collections/${vendorHandle}/${tagHandle}`,
      tag: tagLower, // Keep original for sorting
    });
  }

  if (tempSuggestions.length >= 10) break; // collect more to allow sorting
}

// Check if priority tags exist in tempSuggestions
const hasPriority = tempSuggestions.some((sug) =>
  priorityTags.includes(sug.tag)
);

// Sort: move priority tags first if present
if (hasPriority) {
  tempSuggestions.sort((a, b) => {
    const aIsPriority = priorityTags.includes(a.tag);
    const bIsPriority = priorityTags.includes(b.tag);
    if (aIsPriority && !bIsPriority) return -1;
    if (!aIsPriority && bIsPriority) return 1;
    return 0;
  });
}

// Slice to max 4 suggestions
combinedSuggestions.push(...tempSuggestions.slice(0, 4));

      

      // === SEARCH LINK SECTION ===
      const searchData = [
        {
          html: `<a href="${getSearchUrl(
            term,
            gender
          )}">Search for "${term}"</a>`,
        },
      ];

      // === UPDATE UI SECTIONS ===
      updateSectionContent(".designers-section", "Designers", designersData);
      updateSectionContent(
        ".categories-section",
        "Suggested Categories",
        combinedSuggestions
      );
      updateSectionContent(".search-section", "", searchData, true);

      suggestionsList.classList.remove("hidden");
    } catch (error) {
      console.error("Error rendering suggestions:", error);
    }
  }

  // Search handlers with gender-specific URLs
  searchSubmit.addEventListener("click", (e) => {
    e.preventDefault();
    const value = input.value.trim();
    const gender = genderInput.value;
    if (value.length > 0) {
      const searchUrl = getSearchUrl(value, gender);
      window.location.href = searchUrl;
    }
  });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const value = input.value.trim();
      const gender = genderInput.value;
      if (value.length > 0) {
        const searchUrl = getSearchUrl(value, gender);
        window.location.href = searchUrl;
      }
    }
  });

  // Close drawer on outside click
  document.addEventListener("click", (e) => {
    const isClickInsideDrawer = searchDrawer.contains(e.target);
    const isClickOnButton = Array.from(searchButton).some((btn) =>
      btn.contains(e.target)
    );

    if (
      !isClickInsideDrawer &&
      !isClickOnButton &&
      !searchDrawer.classList.contains("hidden")
    ) {
      searchDrawer.classList.add("hidden");
    }
  });

  // Initialize on page load
  initializeDesigners();
});
